import React, { useRef } from "react";

import DraggableTabs from "./chart/DraggableTabs";

export const DynamicDashboardTabs = ({ addTab, currentTabIndex, setCurrentTabIndex, setTabs, tabs, ...props }) => {
  const handleAdd = () => {
    addTab();
    if (tabsRef.current) tabsRef.current.scrollLeft = tabsRef.current.scrollWidth;
  };

  const tabsRef = useRef();

  return (
    <div {...props}>
      <DraggableTabs
        activeTabIndex={currentTabIndex}
        onAddTab={handleAdd}
        setActiveTabIndex={setCurrentTabIndex}
        setTabs={setTabs}
        tabs={tabs}
      />
    </div>
  );
};
